<script setup>
setPageTitle(PageMeta.Invoices.Add.Title)
definePage({ meta: PageMeta.Invoices.Add.Meta })

import InvoicesEditPage from '@/views/Previews/Invoices/InvoicesEditPage.vue'

/* ** */
</script>

<template>
  <InvoicesEditPage />
</template>
